(function () {
  var MAX_AGE_DAYS = 30;  // hide items not re-verified in this many days
  var MAX_RECS = 6; var PENDING = 'gsc-pending';

  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function has(list, v) { return Array.isArray(list) && list.indexOf(v) > -1; }
  function money(n) { var x = parseFloat(n); return isNaN(x) ? '' : '$' + (x % 1 ? x.toFixed(2) : x.toFixed(0)); }
  function fmtDate(d) {
    var dt = new Date(d + 'T12:00:00');
    return isNaN(dt) ? '' : dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function init(root) {
    if (!root || root.getAttribute('data-gsc-ready')) return;
    root.setAttribute('data-gsc-ready', '1');

    var ITEMS = [], CFG = {};
    try { ITEMS = JSON.parse((root.querySelector('[data-gsc-items]') || {}).textContent || '[]'); } catch (e) { ITEMS = []; }
    try { CFG = JSON.parse((root.querySelector('[data-gsc-config]') || {}).textContent || '{}'); } catch (e) { CFG = {}; }
    var QUESTIONS = (CFG.questions || []).filter(function (q) { return q && q.text; });
    var TIERS = CFG.tiers || [];
    var MAXPTS = QUESTIONS.length * 2;
    if (!QUESTIONS.length) return;

    var state = { step: 'intro', q: 0, answers: [], shopType: '', values: [], region: '', vibes: [] };
    var bar = root.querySelector('.gsc__bar');
    var TOTAL = QUESTIONS.length + 2;
    function $(sel) { return root.querySelector(sel); }
    function field(name) { return root.querySelector('[data-field="' + name + '"]'); }

    function show(step) {
      state.step = step;
      root.querySelectorAll('.gsc__step').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-step') === step);
      });
      var pos = { intro: 0, bonus: 1 + QUESTIONS.length, personalize: 2 + QUESTIONS.length, email: 1 + QUESTIONS.length, results: TOTAL };
      var p = step === 'question' ? 1 + state.q : pos[step];
      bar.style.width = Math.round((p / TOTAL) * 100) + '%';
      var top = root.getBoundingClientRect().top + window.scrollY - 40;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function renderQuestion() {
      var q = QUESTIONS[state.q];
      $('[data-q-count]').textContent = 'Question ' + (state.q + 1) + ' of ' + QUESTIONS.length;
      $('[data-q-text]').textContent = q.text;
      root.querySelectorAll('.gsc__choice').forEach(function (b) {
        b.classList.toggle('is-on', String(state.answers[state.q]) === b.getAttribute('data-value'));
      });
      root.dispatchEvent(new CustomEvent('gsc:question', { bubbles: true, detail: { index: state.q } }));
      show('question');
    }

    function singlePick(name, key) {
      var el = field(name); if (!el) return;
      el.addEventListener('click', function (e) {
        var b = e.target.closest('.gsc__pill'); if (!b) return;
        var was = b.classList.contains('is-on');
        el.querySelectorAll('.gsc__pill').forEach(function (p) { p.classList.remove('is-on'); });
        if (!was) b.classList.add('is-on');
        state[key] = was ? '' : b.getAttribute('data-value');
      });
    }
    function multiPick(name, key, max) {
      var el = field(name); if (!el) return;
      el.addEventListener('click', function (e) {
        var b = e.target.closest('.gsc__pill'); if (!b) return;
        if (!b.classList.contains('is-on') && max && el.querySelectorAll('.is-on').length >= max) return;
        b.classList.toggle('is-on');
        state[key] = Array.prototype.map.call(el.querySelectorAll('.is-on'), function (p) { return p.getAttribute('data-value'); });
      });
    }
    singlePick('shop_type', 'shopType');
    multiPick('values', 'values', 0);
    singlePick('region', 'region');
    multiPick('vibes', 'vibes', 2);

    root.querySelectorAll('.gsc__choice').forEach(function (b) {
      b.addEventListener('click', function () {
        state.answers[state.q] = parseInt(b.getAttribute('data-value'), 10);
        b.classList.add('is-on');
        setTimeout(function () {
          if (state.q < QUESTIONS.length - 1) { state.q++; renderQuestion(); }
          else { show('email'); }
        }, 180);
      });
    });

    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-action]'); if (!a) return;
      var action = a.getAttribute('data-action');
      if (action === 'start') {
        var ok = field('first_name').value.trim() && field('store').value.trim();
        $('[data-error="intro"]').hidden = !!ok;
        if (ok) { state.q = 0; renderQuestion(); }
      }
      if (action === 'back') {
        if (state.step === 'question') { if (state.q > 0) { state.q--; renderQuestion(); } else { show('intro'); } }
        else if (state.step === 'bonus') { state.q = QUESTIONS.length - 1; renderQuestion(); }
        else if (state.step === 'personalize') { show('bonus'); }
        else if (state.step === 'email') { state.q = QUESTIONS.length - 1; renderQuestion(); }
      }
      if (action === 'to-personalize') { show('personalize'); }
      if (action === 'to-email') { show('email'); }
      if (action === 'finish') { finish(a); }
      if (action === 'restart') {
        state.region = ''; state.vibes = [];
        root.querySelectorAll('[data-field="region"] .is-on, [data-field="vibes"] .is-on').forEach(function (p) { p.classList.remove('is-on'); });
        state.q = 0; state.answers = [];
        root.querySelectorAll('.gsc__choice').forEach(function (b) { b.classList.remove('is-on'); });
        show('intro');
      }
    });

    try { var pend = JSON.parse(sessionStorage.getItem(PENDING) || 'null'); if (pend && /customer_posted|gsc-signup|challenge/.test(location.search + location.hash)) { sessionStorage.removeItem(PENDING); state.answers = pend.answers || []; state.shopType = pend.shopType || ''; state.region = pend.region || ''; state.vibes = pend.vibes || []; state.values = pend.values || []; field('first_name').value = pend.firstName || ''; field('store').value = pend.store || ''; field('email').value = pend.email || ''; if (field('wish')) field('wish').value = pend.wish || ''; finish(null, true); setTimeout(function () { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300); } } catch (e) {} function recommend(weakGaps) {
      var now = Date.now();
      var scored = ITEMS.filter(function (it) {
        if (it.show === false) return false;
        if (it.verified) {
          var age = (now - new Date(it.verified + 'T12:00:00').getTime()) / 86400000;
          if (age > MAX_AGE_DAYS) return false;
        }
        return true;
      }).map(function (it) {
        var s = 0;
        if (state.shopType) {
          if (has(it.shop_types, state.shopType)) s += 3;
          else if (!it.shop_types || !it.shop_types.length || has(it.shop_types, 'Any')) s += 1;
          else s -= 2;
        }
        if (state.region) {
          if (has(it.regions, state.region)) s += 3;
          else if (!it.regions || !it.regions.length || has(it.regions, 'Anywhere')) s += 1;
          else s -= 3;
        }
        state.vibes.forEach(function (v) { if (has(it.vibes, v)) s += 2; });
        if (has(weakGaps, 'price-points') && it.tier === 'Under $10') s += 1;
        if (has(weakGaps, 'differentiation') && has(it.vibes, 'Local pride')) s += 1;
        return { it: it, s: s };
      });
      scored.sort(function (a, b) { return b.s - a.s; });
      return scored.slice(0, MAX_RECS).map(function (x) { return x.it; });
    }

    function finish(btn, restoring) {
      var email = field('email').value.trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      $('[data-error="email"]').hidden = valid;
      if (!valid) return;

      var score = 0, weak = [];
      QUESTIONS.forEach(function (q, i) {
        var pts = state.answers[i] || 0;
        score += pts;
        if (pts < 2) weak.push({ q: q, pts: pts });
      });
      weak.sort(function (a, b) { return a.pts - b.pts; });
      var tips = weak.slice(0, 5);
      var tier = TIERS.filter(function (t) { return score / MAXPTS >= t.min; })[0] || { name: '', message: '' };
      var firstName = field('first_name').value.trim();
      var store = field('store').value.trim();

      var tags = ['gift-self-check', 'self-check-score-' + score, 'self-check-tier-' + slug(tier.name)];
      if (state.shopType) tags.push('shop-' + slug(state.shopType));
      if (state.region) tags.push('region-' + slug(state.region));
      state.vibes.forEach(function (v) { tags.push('vibe-' + slug(v)); });
      tips.slice(0, 3).forEach(function (w) { tags.push('gap-' + w.q.gap); });

      var note = 'Gift Section Self-Check\nStore: ' + store + '\nShop type: ' + (state.shopType || '-') +
        '\nRegion: ' + (state.region || '-') + '\nVibe: ' + (state.vibes.join(', ') || '-') +
        '\nScore: ' + score + '/' + MAXPTS + ' (' + tier.name + ')\nValues: ' + (state.values.join(', ') || '-') +
        '\nWish: ' + (field('wish').value.trim() || '-');

      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      body.append('contact[first_name]', firstName);
      body.append('contact[tags]', tags.join(','));
      body.append('contact[note]', note);

      if (restoring) { renderResults(firstName, score, tier, tips, recommend(weak.map(function (w) { return w.q.gap; }))); return; } var base = (root.getAttribute('data-root') || '/').replace(/\/$/, '');
      btn.disabled = true;
      try { sessionStorage.setItem(PENDING, JSON.stringify({ answers: state.answers, shopType: state.shopType, region: state.region, vibes: state.vibes, values: state.values, firstName: firstName, store: store, email: email, wish: (field('wish') || {}).value || '' })); } catch (e) {} var sForm = document.createElement('form'); sForm.method = 'post'; sForm.action = base + '/contact#gsc-signup'; sForm.acceptCharset = 'UTF-8'; sForm.hidden = true; body.forEach(function (v, k) { var inp = document.createElement('input'); inp.type = 'hidden'; inp.name = k; inp.value = v; sForm.appendChild(inp); }); root.appendChild(sForm); var sent = false; var go = function () { if (sent) return; sent = true; if (sForm.requestSubmit) sForm.requestSubmit(); else sForm.submit(); }; if (window.Shopify && Shopify.captcha && Shopify.captcha.protect) { Shopify.captcha.protect(sForm, go); setTimeout(go, 8000); } else { go(); } if (false) fetch(base + '/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
        credentials: 'same-origin'
      }).catch(function () {}).then(function () {
        btn.disabled = false;
        renderResults(firstName, score, tier, tips, recommend(weak.map(function (w) { return w.q.gap; })));
      });
    }

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text) n.textContent = text;
      return n;
    }

    function renderRecs(recs) {
      var wrap = $('[data-r-recs-wrap]'), list = $('[data-r-recs]');
      if (!wrap || !list) return;
      list.innerHTML = '';
      if (!recs.length) { wrap.hidden = true; return; }
      var latest = '';
      recs.forEach(function (it) {
        if (it.verified && it.verified > latest) latest = it.verified;
        var card = el('div', 'gsc__rec');
        if (it.image) {
          var img = el('img', 'gsc__rec-img'); img.src = it.image; img.alt = it.name || ''; img.loading = 'lazy';
          card.appendChild(img);
        }
        var bodyEl = el('div', 'gsc__rec-body');
        bodyEl.appendChild(el('p', 'gsc__rec-name', it.name));
        if (it.vendor) bodyEl.appendChild(el('p', 'gsc__rec-vendor', it.vendor));
        var meta = [];
        if (it.retail) meta.push(money(it.retail) + ' retail');
        if (it.wholesale) meta.push(money(it.wholesale) + ' wholesale');
        if (it.minimum) meta.push('Min ' + it.minimum);
        if (it.ship) meta.push('Ships ' + it.ship);
        if (meta.length) bodyEl.appendChild(el('p', 'gsc__rec-meta', meta.join(' · ')));
        if (it.why) bodyEl.appendChild(el('p', 'gsc__rec-why', it.why));
        if (it.link) {
          var a = el('a', 'gsc__rec-link', 'See it →'); a.href = it.link; a.target = '_blank'; a.rel = 'noopener';
          bodyEl.appendChild(a);
        }
        card.appendChild(bodyEl);
        list.appendChild(card);
      });
      var note = $('[data-r-recs-note]');
      if (note) note.textContent = (latest ? 'In stock and shipping fast as of ' + fmtDate(latest) + '. ' : '') + 'No paid placements, ever.';
      wrap.hidden = false;
    }

    function enhance(tier) { var CA = CFG.catAudit || {}, CN = CFG.cats || {}, CT = CFG.ctas || {}; var ti = TIERS.indexOf(tier); if (!document.getElementById('gsc-enh-css')) { var st = document.createElement('style'); st.id = 'gsc-enh-css'; st.textContent = '.gsc__xflag{display:block;font-weight:600;font-size:11px;color:var(--gsc-accent);text-transform:uppercase;letter-spacing:.06em;margin-top:2px}.gsc .gsc__sc-row.is-low .gsc__sc-name{color:var(--gsc-accent)}.gsc__xbox{margin:0 0 20px;padding:18px 20px;border-radius:12px;background:var(--gsc-bg);text-align:left;font-size:16px;line-height:1.55}.gsc__xbox p{margin:0 0 10px}.gsc__xbox p:last-child{margin:0}.gsc__xhook{font-weight:600}.gsc__xprice{font-size:14px;opacity:.8}'; document.head.appendChild(st); } var order = ['know', 'buy', 'display', 'standout'], tot = {}, max = {}, low = null; QUESTIONS.forEach(function (q, i) { var c = q.cat || 'know'; tot[c] = (tot[c] || 0) + (state.answers[i] || 0); max[c] = (max[c] || 0) + 2; }); order.forEach(function (c) { if (max[c] && (low === null || tot[c] / max[c] < tot[low] / max[low])) low = c; }); setTimeout(function () { var sc = $('.gsc__scorecard'); if (!sc) return; sc.querySelectorAll('.gsc__xflag').forEach(function (f) { f.remove(); }); var rows = sc.querySelectorAll('.gsc__sc-row'); rows.forEach(function (r) { r.classList.remove('is-low'); }); var r = rows[order.filter(function (c) { return max[c]; }).indexOf(low)]; if (r) { r.classList.add('is-low'); (r.querySelector('.gsc__sc-name') || r).appendChild(el('span', 'gsc__xflag', 'Your biggest opportunity')); } }, 0); var cta = $('.gsc__cta'); if (!cta) return; var p = cta.querySelector(':scope > p:not(.gsc__call)'), btn = cta.querySelector('a.gsc__btn'); var box = cta.querySelector('[data-r-box]'); if (!box) { box = el('div', 'gsc__xbox'); box.setAttribute('data-r-box', ''); cta.insertBefore(box, btn || null); } box.innerHTML = ''; var hook = [CT.star, CT.bones, CT.money][ti]; if (hook) box.appendChild(el('p', 'gsc__xhook', hook)); if (ti === 0 && CT.starAlt) box.appendChild(el('p', '', CT.starAlt)); if (low && CA[low]) { var a = el('p'); a.appendChild(document.createTextNode('In the audit, I start with ')); a.appendChild(el('strong', '', CN[low] || low)); a.appendChild(document.createTextNode(': ' + CA[low])); box.appendChild(a); } if (CFG.urgency) box.appendChild(el('p', 'gsc__xprice', CFG.urgency)); box.hidden = !box.childNodes.length; if (p) p.hidden = !box.hidden; } function renderResults(firstName, score, tier, tips, recs) {
      $('[data-r-hello]').textContent = 'Nice work, ' + firstName + '. Here’s your score';
      $('[data-r-score]').textContent = score;
      var mx = $('[data-r-max]'); if (mx) mx.textContent = '/' + MAXPTS;
      $('[data-r-tier]').textContent = tier.name;
      $('[data-r-message]').textContent = tier.message;
      var ul = $('[data-r-tips]'); ul.innerHTML = '';
      tips.forEach(function (w) { var li = document.createElement('li'); li.textContent = w.q.tip; ul.appendChild(li); });
      $('[data-r-tips-wrap]').hidden = tips.length === 0;
      renderRecs(recs); enhance(tier);
      root.dispatchEvent(new CustomEvent('gsc:results', { bubbles: true, detail: { answers: state.answers.slice(), score: score } }));
      show('results');
    }
  }

  function initAll() { document.querySelectorAll('.gsc').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);

  var cs = document.currentScript;
  if (cs && cs.src && !window.__gscVisuals) {
    window.__gscVisuals = 1;
    var v = document.createElement('script');
    v.src = cs.src.replace('gift-self-check.js', 'gift-self-check-visuals.js');
    document.head.appendChild(v);
  }
})();
